/**
 * @desc 创建领用单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.LendMasterCreateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/lendMaster/add`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
